module.exports = __webpack_public_path__ + "static/img/bg-worldview.73a3f2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web-firehero/tw/h5/imgs/bg-worldview.png
// module id = D4Iv
// module chunks = 13